import React, { useState, useEffect, Fragment } from 'react';
import { Form } from 'react-final-form';
import {
  required,
  // number,
  useDataProvider,
  useNotify,
  useRefresh,
  usePermissions,
  cacheDataProviderProxy,
} from 'react-admin';
import { DialogActions, DialogContent } from '@material-ui/core';
import {
  FormTextField,
  handleNumbers,
  getDateInputValue,
  composeValidators,
  validateDate,
} from '.';
import { SaveButton } from '../../../../design';
import { DeleteRecord } from '../../../wrappers';
import { useStyles } from '../modal.styles';

export const EditMltcPayer = ({
  caseId,
  record = {},
  handleClose,
  closeAside,
}) => {
  const classes = useStyles();
  const refresh = useRefresh();
  const dataProvider = cacheDataProviderProxy(useDataProvider());
  const notify = useNotify();
  const [formData, setFormData] = useState({});
  const { permissions = '' } = usePermissions();
  const userPermissions = permissions.split(',');

  useEffect(() => {
    if (record) {
      const { active_date, name } = record;
      setFormData(f => ({
        ...f,
        active_date,
        name,
      }));
    }
  }, [record]);

  const onSubmit = value => {
    return dataProvider
      .update('mltc-payer', {
        id: record.id,
        data: { ...value },
        previousData: { ...record },
      })
      .then(({ data }) => {
        notify('form.updated');
        handleClose();
        typeof refresh === 'function' && refresh();
      })
      .catch(error =>
        notify(
          typeof error === 'string'
            ? error
            : error.message || 'ra.notification.http_error',
          'warning',
        ),
      );
  };
  const customOnChange = async (eventOrValue, _name, type) => {
    // when using a react-admin input, onChange returns
    // the value instead of the target.
    let value = eventOrValue;
    let name = _name;
    if (typeof eventOrValue === 'object') {
      const target = eventOrValue.target;
      value = target.type === 'checkbox' ? target.checked : target.value;
      name = target.name;
    }
    if (type === 'number') {
      value = handleNumbers(value);
    }
    if (type === 'date') {
      value = getDateInputValue(value);
    }

    setFormData({ ...formData, [name]: value });
  };

  return (
    <Fragment>
      <Form
        onSubmit={onSubmit}
        initialValues={{
          // ...caseFields,
          ...formData,
        }}
        render={({
          submitError,
          handleSubmit,
          form,
          submitting,
          pristine,
          values,
        }) => {
          return (
            <form onSubmit={handleSubmit}>
              <DialogContent>
                <FormTextField
                  name='name'
                  label='Name'
                  customOnChange={customOnChange}
                  validate={required()}
                  required
                  fullWidth
                />
                <FormTextField
                  name='active_date'
                  label='Effective Date'
                  customOnChange={customOnChange}
                  type='date'
                  validate={composeValidators([required(), validateDate()])}
                  required
                />
              </DialogContent>
              <DialogActions
                className={classes.padding16}
                style={{ paddingBottom: 16, justifyContent: 'space-between' }}
              >
                {userPermissions.indexOf('admin') > -1 ||
                userPermissions.indexOf('supervisor') > -1 ? (
                  <DeleteRecord
                    handleClose={handleClose}
                    resource='mltc-payer'
                    id={record.id}
                    record={record}
                    onClick={
                      typeof closeAside === 'function' ? closeAside : undefined
                    }
                  />
                ) : (
                  <span />
                )}
                <SaveButton
                  className={classes.saveButton}
                  disabled={submitting}
                  type='submit'
                />
              </DialogActions>
            </form>
          );
        }}
      />
    </Fragment>
  );
};
